var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGold = function SvgGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EFD287",
    stroke: "url(#gold_svg__a)",
    strokeWidth: 1.039,
    d: "M77.693 8.82c.818 3.07 1.233 7.847 1.442 11.895a165 165 0 0 1 .207 7.137v.145h.52-.52v.147l-.003.422a164.797 164.797 0 0 1-.204 6.714c-.208 4.048-.623 8.826-1.44 11.896-.87 3.273-3.432 5.85-6.682 6.725-1.5.404-4.178.716-7.393.952-3.201.236-6.892.392-10.393.497a493 493 0 0 1-12.947.21H40v.519-.52h-.281l-.8-.003a492.991 492.991 0 0 1-12.146-.206c-3.502-.105-7.193-.261-10.394-.497-3.216-.236-5.893-.548-7.393-.952-3.25-.874-5.812-3.452-6.681-6.725-.818-3.07-1.233-7.848-1.441-11.896a165 165 0 0 1-.207-7.137v-.145h-.52.52v-.147q0-.145.002-.422a165.02 165.02 0 0 1 .204-6.714c.21-4.048.625-8.826 1.442-11.896.87-3.273 3.432-5.85 6.682-6.725 1.5-.404 4.177-.716 7.392-.952C19.58.906 23.271.75 26.772.645A493 493 0 0 1 39.72.435h.28v-.519.52h.281l.8.003a493.124 493.124 0 0 1 12.146.206c3.502.105 7.193.261 10.393.496 3.216.237 5.893.549 7.393.953 3.25.874 5.811 3.452 6.681 6.725Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9259",
    fillOpacity: 0.49,
    d: "M77.213 10.44C76.665 6 73.33 3.333 69.907 2.665 64.634 1.16 56.205 1.34 54.059 1.34l-7.03 27.903-7.031 25.422c2.147 0 24.636.106 29.908-1.398 4.092-.6 6.759-3.934 7.306-7.775 1.436-5.707 1.453-17.046 1.453-17.526s-.017-11.82-1.452-17.524"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.709 15.945V40.05l21.188-12.051z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold_svg__a",
    x1: 0.137,
    x2: 79.862,
    y1: 27.997,
    y2: 27.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A6128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#FFF8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#FFF3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#926E32"
  })))));
};
export default SvgGold;